import React, { FunctionComponent, ReactElement } from 'react'

import './SocialMedia.scss'

export interface OwnProps {}

type Props = OwnProps

import instagramIcon from '@assets/images/social/instagram.png'
import facebookIcon from '@assets/images/social/facebook.png'
import twitterIcon from '@assets/images/social/twitter.png'
import facebookHoverIcon from '@assets/images/icons/social/facebook-hover.png'
import instagramHoverIcon from '@assets/images/icons/social/instagram-hover.png'
import twitterHoverIcon from '@assets/images/icons/social/twitter-hover.png'
import { useTranslation } from 'react-i18next'

const socialIcons = [
  {
    text: 'Instagram',
    icon: instagramIcon,
    hoverIcon: instagramHoverIcon,
    href: 'instagramLink',
  },
  {
    text: 'Facebook',
    icon: facebookIcon,
    hoverIcon: facebookHoverIcon,
    href: 'facebookLink',
  },
  {
    text: 'Twitter',
    icon: twitterIcon,
    hoverIcon: twitterHoverIcon,
    href: 'twitterLink',
  },
]

export function SocialMedia() {
  const { t } = useTranslation('SocialMedia')
  return (
    <div className="SocialMedia">
      {socialIcons.map((socialIcon) => {
        return (
          <div className="social-media-icon" key={socialIcon.text}>
            <a href={t(socialIcon.href)} rel="noreferrer" target="_blank">
              <img className="-icon" src={socialIcon.icon} alt={socialIcon.text} />
              <img className="-hover-icon" src={socialIcon.hoverIcon} alt={socialIcon.text} />
            </a>
          </div>
        )
      })}
    </div>
  )
}

export default SocialMedia
